import clsx from 'clsx';
import {
	Badge,
	LabelState,
	LabelLawyerState,
	Spinner,
	Typography,
} from '@/components/common';
import { StatusCardProps } from '@/interfaces';
import { isCaseCardDisabled } from '@/utils/caseStatus';
import { getCaseStatusColor } from '@/lib';
import { useRouter } from 'next/router';
import AppRoutes from '@/const/routes';
import { Earned } from './Earned';
import { PinButton } from './status-card/PinButton';
import { CaseOverviewLink } from './status-card/CaseOverviewLink';

export const StatusCard: React.FC<StatusCardProps> = ({
	status,
	phaseName,
	title,
	classNameTitle,
	step_name,
	isPinned,
	textSize,
	children,
	category,
	nonePinClick,
	earned,
	showPin,
	classNameContainer,
	isLoading,
	clientApproveEmail,
	onClickPin,
	onClickOverview,
}) => {
	const router = useRouter();
	const pathname = router.pathname;

	return (
		<div
			className={clsx(
				'rounded-2xl bg-white border border-[#0D061614] px-4 py-6 md:px-6 md:py-6 space-y-8 md:space-y-12',
				{
					'!bg-bg-disabled border border-[#0D061614]': isCaseCardDisabled({
						status,
						stepName: step_name,
						clientApproveEmail,
					}),
				},
				classNameContainer
			)}
		>
			{isLoading ? (
				<div className="flex items-center justify-center my-10">
					<Spinner className="w-8 h-8" />
				</div>
			) : (
				<>
					<div id="card-header" className="flex flex-col gap-4">
						<div className="flex flex-col md:flex-row md:items-center justify-between w-full gap-3 md:gap-0">
							<div className="order-2">
								{pathname.includes(AppRoutes.CLIENTAPP) && (
									<LabelState status={status} showDot={false} />
								)}
								{pathname.includes(AppRoutes.LAWYERAPP) && (
									<LabelLawyerState
										status={status}
										statusColor={getCaseStatusColor(status)}
										phaseName={phaseName}
										showDot={false}
									/>
								)}
							</div>
							<div
								className={`flex items-center order-1 md:order-2 gap-5 justify-between lg:justify-start w-auto min-h-[34px] ${
									isPinned || showPin ? 'block' : 'hidden'
								}`}
							>
								{onClickOverview && (
									<CaseOverviewLink onClick={onClickOverview} />
								)}
								{(isPinned || showPin) && (
									<div>
										<PinButton
											isPinned={isPinned}
											onClick={onClickPin}
											noneClick={nonePinClick}
										/>
									</div>
								)}
							</div>
						</div>
						<div className="flex flex-wrap items-center justify-between md:mt-0">
							<div className="flex flex-col lg:flex-row lg:items-center gap-4">
								<Typography
									type={textSize}
									className={clsx('prose text-left', classNameTitle)}
								>
									{title}
								</Typography>
								{category && <Badge type={category} />}
							</div>
							{earned
								? earned > 0 &&
								  status === 'Resolved Case' && <Earned earned={earned} />
								: null}
						</div>
					</div>
					{children}
				</>
			)}
		</div>
	);
};
